export const getters = {
  selected_address(state) {
    return state.selected_address;
  },
};
